import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import VehicleService from '@services/vehicle'

export const getAllRcPrintList = createAsyncThunk('rcPrintList/getAllRcPrintList', async (params, { rejectWithValue }) => {
  try {
    const response = await VehicleService.getAllRcPrintlist(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getRcPrintById = createAsyncThunk('rcPrintList/getRcPrintById', async (id, { rejectWithValue }) => {
  try {
    const response = await VehicleService.getPrintRcById(id)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

const rcPrintListSlice = createSlice({
  name: 'rcPrintList',
  initialState: {
    data: [],
    total: 1,
    params: {},
    loading: false,
    selectedRcPrint: null
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllRcPrintList.pending, (state) => {
        state.loading = true
      })
      .addCase(getAllRcPrintList.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.loading = false
      })
      .addCase(getAllRcPrintList.rejected, (state) => {
        state.loading = false
      })
      .addCase(getRcPrintById.fulfilled, (state, action) => {
        state.selectedRcPrint = action.payload
      })
  }
})

export default rcPrintListSlice.reducer
